// src/components/Sidebar.js
import { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LockIcon from "@mui/icons-material/Lock";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const Sidebar = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (isOpen) => () => {
    setOpen(isOpen);
  };

  return (
    <>
      {/* Hamburger Icon for Small Screens */}
      <IconButton
        onClick={toggleDrawer(true)}
        sx={{
          display: { xs: "block", md: "none" },
          position: "absolute",
          top: 50,
          left: 20,
          color: "white",
        }}
      >
        <MenuIcon />
      </IconButton>

      {/* Sidebar */}
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        variant="permanent"
        sx={{
          width: 250,
          flexShrink: 0,
          position: "fixed",
          top: "80px", // Header ke neeche start hoga (agar header 64px ka hai)
          "& .MuiDrawer-paper": {
            width: 250,
            backgroundColor: "#12174A",
            color: "white",
            borderRight: "2px solid white",
            top: "80px", // Same as Drawer to align properly
            height: "calc(100vh - 64px)", // Full height except header
          },
          display: { xs: "none", md: "block" }, // Hide on small screens
        }}
      >
        <Box sx={{ padding: "10px" }}>
          {/* Top Button */}
          <ListItemButton
            sx={{
              backgroundColor: "white",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <ListItemIcon>
              <EventIcon sx={{ color: "#FFC107" }} />
            </ListItemIcon>
            <ListItemText primary="Exercise Regime" sx={{ color: "black" }} />
          </ListItemButton>

          {/* Sections */}
          <Typography
            variant="subtitle2"
            sx={{ padding: "10px 16px", fontWeight: "bold" }}
          >
            SELF
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <AccessTimeIcon sx={{ color: "gray" }} />
                </ListItemIcon>
                <ListItemText primary="My Progress" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <LockIcon sx={{ color: "gray" }} />
                </ListItemIcon>
                <ListItemText primary="My Prescription" />
              </ListItemButton>
            </ListItem>
          </List>

          <Typography
            variant="subtitle2"
            sx={{ padding: "10px 16px", fontWeight: "bold" }}
          >
            ME
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <ReceiptLongIcon sx={{ color: "gray" }} />
                </ListItemIcon>
                <ListItemText primary="Invoices/Lasers" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>

      {/* Responsive Drawer for Small Screens */}
      <Drawer
  anchor="left"
  open={open}
  onClose={toggleDrawer(false)}
  variant="permanent"
  sx={{
    position: "fixed",
    top: "64px", // Header ke neeche start hoga
    height: "calc(100vh - 64px)", // Header ke baad pura screen cover karega
    "& .MuiDrawer-paper": {
      width: 250,
      backgroundColor: "#12174A",
      color: "white",
      borderRight: "2px solid white",
      top: "64px", // Drawer ki paper bhi header ke neeche rahe
      height: "calc(100vh - 64px)",
    },
  }}
>

        <Box sx={{ padding: "10px" }}>
          <ListItemButton
            sx={{
              backgroundColor: "white",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <ListItemIcon>
              <EventIcon sx={{ color: "#FFC107" }} />
            </ListItemIcon>
            <ListItemText primary="Exercise Regime" sx={{ color: "black" }} />
          </ListItemButton>

          <Typography
            variant="subtitle2"
            sx={{ padding: "10px 16px", fontWeight: "bold" }}
          >
            SELF
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <AccessTimeIcon sx={{ color: "gray" }} />
                </ListItemIcon>
                <ListItemText primary="My Progress" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <LockIcon sx={{ color: "gray" }} />
                </ListItemIcon>
                <ListItemText primary="My Prescription" />
              </ListItemButton>
            </ListItem>
          </List>

          <Typography
            variant="subtitle2"
            sx={{ padding: "10px 16px", fontWeight: "bold" }}
          >
            ME
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <ReceiptLongIcon sx={{ color: "gray" }} />
                </ListItemIcon>
                <ListItemText primary="Invoices/Lasers" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
